import React from 'react';
import { Avatar } from '@mui/material';

/**
 * Team crest from /static/teamlogos/{SHORT}.png (e.g. RR.png, MI.png).
 *
 * Stateless on purpose: MUI Avatar falls back to its children (the monogram)
 * whenever the image fails, and retries automatically when `src` changes.
 * A previous version cached the failure in state, which made logos vanish
 * for teams whose file existed after any transient load error.
 */
const TeamLogo: React.FC<{ short?: string | null; size?: number }> = ({ short, size = 28 }) => {
  const code = (short || '').toUpperCase();
  return (
    <Avatar
      src={code ? `/static/teamlogos/${code}.png` : undefined}
      alt={code || 'team'}
      sx={{
        width: size,
        height: size,
        bgcolor: 'white',
        border: '1px solid',
        borderColor: 'divider',
        color: 'text.secondary',
        fontSize: size * 0.32,
        fontWeight: 700,
        '& img': { objectFit: 'contain', p: '2px' },
      }}
    >
      {code || '?'}
    </Avatar>
  );
};

export default TeamLogo;
